module.exports = __webpack_public_path__ + "static/media/clock-notebook.4cbaf748.svg";